import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { propertyFieldTypes } from '../../../constants/properties';
import useSelectFilterOptions from '../../../hooks/useSelectFilterOptions';
import useSelectLinkedProperties from '../../../hooks/useSelectLinkedProperties';
import useSelectLoadOptions from '../../../hooks/useSelectLoadOptions';
import useSelectOptions from '../../../hooks/useSelectOptions';
import useSelectValues from '../../../hooks/useSelectValues';
import { StyledUISelectWrapper } from './InputWithDropdown.style';
import { jsx as _jsx } from "react/jsx-runtime";
function InputWithDropdown({
  property,
  onFormValueChanged,
  currentValue,
  editMode,
  disabled,
  appName,
  objectType,
  correlatedField,
  correlatedFieldValue,
  defaultOpen,
  hubspotUserId
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const selectValue = useMemo(() => {
    if (property.type === 'enumeration' && property.fieldType === propertyFieldTypes.checkbox && currentValue) return currentValue.split(';').filter(el => el);
    return currentValue || '';
  }, [property, currentValue]);
  const openHandler = () => setIsOpen(v => !v);
  const onInputChange = event => {
    setInputValue(event.target.value);
  };
  const setExternalValue = useCallback(data => {
    const value = property.fieldType === propertyFieldTypes.checkbox ? data.join(';') : data;
    onFormValueChanged({
      key: property.name,
      value,
      required: property.required || false
    });
  },
  // this function don`t depend on changing data (it uses only references)
  // if fill deps it cause infinite loops
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const onChangeEvent = useCallback(event => {
    setExternalValue(event.target.value);
  }, [setExternalValue]);
  useEffect(() => {
    if (defaultOpen) {
      setIsOpen(defaultOpen);
    }
  }, [defaultOpen]);
  const {
    fetchedExternadOptions,
    referenceType
  } = useSelectValues({
    property,
    objectType
  });
  const {
    loadOptions
  } = useSelectLoadOptions({
    property,
    objectType
  });
  const filterOptions = useSelectFilterOptions({
    referenceType,
    correlatedField,
    correlatedFieldValue,
    objectType,
    inputValue
  });
  const {
    selectOptions,
    isDisabled
  } = useSelectOptions({
    property,
    objectType,
    currentValue,
    loadOptions,
    hubspotUserId,
    setExternalValue
  });
  useSelectLinkedProperties({
    referenceType,
    correlatedField,
    selectValue,
    objectType,
    onFormValueChanged
  });
  return /*#__PURE__*/_jsx(StyledUISelectWrapper, {
    editMode: editMode,
    children: /*#__PURE__*/_jsx(Select, {
      "aria-label": "select",
      disabled: isDisabled || disabled,
      isLoading: fetchedExternadOptions === null || fetchedExternadOptions === void 0 ? void 0 : fetchedExternadOptions.isLoading,
      buttonUse: editMode ? 'transparent' : 'form',
      "data-test-id": `${appName}-form-select-input`,
      multi: property.fieldType === propertyFieldTypes.checkbox,
      anchorType: property.fieldType === propertyFieldTypes.checkbox ? 'button' : 'auto',
      onChange: onChangeEvent,
      options: property.externalOptions ? selectOptions : property.options.map(el => Object.assign({}, el, {
        text: el.label
      })),
      placeholder: I18n.text('associationsPanel.tabs.create.select'),
      value: selectValue,
      filterOptions: filterOptions,
      open: isOpen,
      onOpenChange: openHandler,
      inputValue: inputValue,
      onInputValueChange: onInputChange,
      error: fetchedExternadOptions === null || fetchedExternadOptions === void 0 ? void 0 : fetchedExternadOptions.isError
    })
  });
}
export default InputWithDropdown;